import React from 'react';
import { Box, TextField, MenuItem,InputAdornment } from '@mui/material';
import styled from '@emotion/styled';
import ErrorMsg from './ErrorMsg';

import { tokens } from "../theme";
const TextBox = styled(Box)({
  fontSize: '1rem',
  lineHeight: '1.5rem',
  color: tokens.textMuted,
  marginBottom: '4px'
});

const InputStyle = {
  borderRadius: '10px',
  fontSize: '1rem',
  lineHeight: '1.5rem',
  fontWeight:400,
  color: '#2A1D22CC',
}

// Keep disabled (read/view-mode) values legible instead of washed out.
const disabledTextSx = {
  "& .MuiInputBase-input.Mui-disabled, & .MuiSelect-select.Mui-disabled": {
    WebkitTextFillColor: "#2A1D22",
    color: "#2A1D22",
    opacity: 1,
  },
  "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: "#EAD8CC",
  },
};

const FormField = ({ label,placeholder, type, value, width, height, disabled, options,disabledOptions, onChange, onBlur, fullwidth, validation, row, endAdornment, noMargin}) => {
  // The book wants a failed field marked, not just annotated: "Validation
  // appears on the field, on leaving it." The theme already draws a 2px danger
  // outline for Mui-error — this is what finally reaches it, so an error is
  // carried by the control as well as by the line underneath.
  const invalid = Boolean(validation);

  return (
    <Box sx={{width: width?width:(fullwidth?'100%':'48%'), marginBottom: noMargin ? 0 : '1.125rem' }}>
      <TextBox>{label}</TextBox>
      {type === 'select' ? (
        <TextField
          id="outlined-basic"
          select
          variant="outlined"
          onChange={onChange}
          onBlur={onBlur}
          error={invalid}
          fullWidth
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          sx={{
            '& .MuiInputBase-root': {...InputStyle, height: height? height : (row? `${3 * row}rem`:"3rem"), paddingInline: row? `1rem`:"none"},
            "& .MuiOutlinedInput-notchedOutline":{
                border: `1px solid ${tokens.border}`
            },
            ...disabledTextSx,
          }}
        >
          {options &&
            options.map((option) => (
              typeof option === 'object' ? (
                <MenuItem key={option._id} value={option.value} disabled={disabledOptions?.includes(option.value)}>
                  {option.name}
                </MenuItem>
              ) : (
                <MenuItem key={option} value={option} disabled={disabledOptions?.includes(option)}>
                  {option}
                </MenuItem>
              )
            ))}
        </TextField>
      )  :  type === 'file' ? (
      <input
        type="file"
        onChange={onChange}
        style={{
          ...InputStyle,
          display: 'block',
          border: `1px solid ${tokens.border}`,
          padding: '8px',
          width: '100%',
          boxSizing: 'border-box',
        }}
      />
    ) :  (
        <TextField
          id="outlined-basic"
          variant="outlined"
          onChange={onChange}
          onBlur={onBlur}
          error={invalid}
          fullWidth
          value={value}
          multiline={fullwidth}
          placeholder={placeholder}
          disabled={disabled}
          rows={row}
          sx={{
            '& .MuiInputBase-root': {...InputStyle, height: height? height : (row? `${3 * row}rem`:"3rem")},
              "& .MuiOutlinedInput-notchedOutline":{
                  border: `1px solid ${tokens.border}`
              },
              "&:hover .MuiOutlinedInput-notchedOutline":{
                  borderColor: tokens.textMuted
              },
              // A field that is both focused and wrong stays red: it is the
              // more urgent of the two states, and the plum focus ring would
              // otherwise hide the failure the moment someone went back to fix it.
              "& .Mui-focused .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":{
                  borderColor: invalid ? tokens.danger : '#8C3B5E',
                  borderWidth: invalid ? '2px' : '1px'
              },
              ...disabledTextSx,
          }}
          InputProps={{
            endAdornment: endAdornment?(
              <InputAdornment position="end">
                 {endAdornment}
              </InputAdornment>
            ) : null     
          }}
        />
      )}
      <ErrorMsg>{validation}</ErrorMsg>
    </Box>
  );
};

export default FormField;
